<div class="button-container" [class.disabled-button]="disabled()">
    <ui-button
        [id]="id() + '-btn'"
        [label]="label()"
        [severity]="'secondary'"
        [outlined]="true"
        [text]="text()"
        [disabled]="disabled()"
        (onClick)="onClick.emit($event)"></ui-button>
</div>
